<div class="search-bar-container">
    <div class="search-icon-wrapper" (click)="submitSearch()">
        <img src="assets/images/search.png" height="16px" alt="search">
    </div>
    <input *ngIf="allowDebounce; else noDebounce" placeholder="Search..." class="search-bar" #myInputDebounce
        [(ngModel)]="searchQuery" (keypress)="validateInput($event)"
        (ngModelChange)="debouncedSearch(myInputDebounce.value)">
    <ng-template #noDebounce>
        <input placeholder="Search..." class="search-bar" #myInput [(ngModel)]="searchQuery"
            (keypress)="validateInput($event)" (ngModelChange)="submitInput(myInput.value)"
            (input)="filterItem(myInput.value)" (keydown)="searchByKey($event)">
    </ng-template>
</div>